import React from 'react';

export type Tab = 'personnage' | 'faction' | 'aide' | 'options';

const TABS: Array<{ id: Tab; label: string; hint: string }> = [
  { id: 'personnage', label: 'Personnage', hint: 'Identité, métiers, biens' },
  { id: 'faction', label: 'Faction', hint: 'Membres, annonces, gestion' },
  { id: 'aide', label: 'Aide', hint: 'Mécaniques et commandes' },
  { id: 'options', label: 'Options', hint: 'Son, interface, palette' },
];

interface Props {
  tab: Tab;
  onChangeTab: (tab: Tab) => void;
  characterName: string | null;
  septims: number | null;
  onResume: () => void;
  onQuit: () => void;
}

// Left rail of the menu: brand, the four sections, and the two actions that
// leave it (resume, quit). The character's name and purse sit at the foot so
// they stay visible from every section.
const Rail: React.FC<Props> = ({ tab, onChangeTab, characterName, septims, onResume, onQuit }) => {
  return (
    <aside className="esc-rail">
      <div className="esc-brand">
        <span className="esc-brand__name">Altherys</span>
        <span className="esc-brand__sub">Skyrim Roleplay</span>
      </div>

      <nav className="esc-nav" aria-label="Menu principal">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={'esc-nav__item' + (tab === t.id ? ' esc-nav__item--active' : '')}
            aria-current={tab === t.id ? 'page' : undefined}
            onClick={() => onChangeTab(t.id)}
          >
            <span className="esc-nav__label">{t.label}</span>
            <span className="esc-nav__hint">{t.hint}</span>
          </button>
        ))}
      </nav>

      <div className="esc-rail__foot">
        {characterName && (
          <div className="esc-identity">
            <span className="esc-identity__name">{characterName}</span>
            {septims !== null && <span className="esc-identity__gold">{septims.toLocaleString('fr-FR')} Septims</span>}
          </div>
        )}
        <button type="button" className="esc-btn esc-btn--primary esc-rail__resume" onClick={onResume}>
          Reprendre
          <kbd className="esc-kbd">Échap</kbd>
        </button>
        <button type="button" className="esc-btn esc-btn--quiet esc-rail__quit" onClick={onQuit}>
          Quitter le jeu
        </button>
      </div>
    </aside>
  );
};

export default Rail;
